/**
 * Date picker for rule-modal action values when the selected field is TIMESTAMP/DATE.
 */

import moment from "moment";
import { DateInput } from "risa-oasis-ui_v2";
import {
  formatDateInputValueForStorage,
  formatTimestampValueForDateInput,
} from "../../queryBuilder/queryBuilderUtils";
import { toValueString } from "./ruleFormConstants";

interface ActionDateValueInputProps {
  /** Stable id for the DateInput control. */
  id: string;
  /** Column label shown on the first action row only. */
  label: string;
  /** When false, the control is visually disabled until a field is selected. */
  enabled: boolean;
  value: string | string[];
  onValueChange: (value: string) => void;
}

/**
 * Renders a date picker for action values stored as ISO instants or MM/DD/YYYY.
 */
const ActionDateValueInput = ({
  id,
  label,
  enabled,
  value,
  onValueChange,
}: ActionDateValueInputProps) => {
  const stored = toValueString(value);

  return (
    <div className="flex flex-col gap-1">
      {label ? (
        <label
          htmlFor={id}
          className="text-tiny font-medium text-primaryGray-3"
        >
          {label}
        </label>
      ) : null}
      <div
        className={enabled ? "w-full" : "pointer-events-none w-full opacity-50"}
      >
        <DateInput
          id={id}
          label=""
          format="MM/DD/YYYY"
          defaultValue={formatTimestampValueForDateInput(stored)}
          onChange={(data: { value: string }) =>
            onValueChange(
              data.value
                ? formatDateInputValueForStorage(
                    moment(data.value).isValid()
                      ? moment(data.value).format("MM/DD/YYYY")
                      : String(data.value),
                  )
                : "",
            )
          }
        />
      </div>
    </div>
  );
};

export default ActionDateValueInput;
